module.exports = __webpack_public_path__ + "static/media/ic-overhead-squat.df52d2ea.svg";